module.exports = __webpack_public_path__ + "static/media/searchDark.99416cd2.svg";